exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-daterange-picker[data-v-2b5f5b5c] .form-control {\n    height: 32px;\n    box-shadow: 0 2px 3px #0000000D;\n    font: Normal 13px/20px Source Sans Pro;\n}\n", ""]);

// exports
